/*
 * A native `<select>` wearing the field control's box and the product's own chevron. The element
 * stays native — the keyboard, the touch picker and the screen-reader announcement are the
 * browser's — and only the drawing changes: `appearance: none` takes the platform arrow away and
 * the 16 px `chevronDown` of the icon set stands in its place, so a select and a field beside it
 * are one family. Inside a `Field`, spread the control props it hands over and the label is wired.
 */

import type { SelectHTMLAttributes } from "react"
import { Icon } from "../core/shell/icons.tsx"
import { cx } from "../lib/cx.ts"
import { FIELD_CONTROL_CLASS } from "./Field.tsx"
import "./ui.css"

export function Select({ className, ...select }: SelectHTMLAttributes<HTMLSelectElement>) {
	// A `Field` already hands the class over; a bare select gets it here. One class, not two.
	const classes =
		className?.split(" ").includes(FIELD_CONTROL_CLASS) === true
			? className
			: cx(FIELD_CONTROL_CLASS, className)
	return (
		<span className="tb-select">
			<select className={classes} {...select} />
			<Icon name="chevronDown" size={16} />
		</span>
	)
}
